import DOMPurify from "dompurify";

export function sanitizeNewsContent(html) {
  const sanitized = DOMPurify.sanitize(html || "", {
    FORBID_ATTR: ["style", "face", "color", "size"],
  });
  const template = document.createElement("template");
  template.innerHTML = sanitized;

  template.content.querySelectorAll("p").forEach((paragraph) => {
    const text = (paragraph.textContent || "").replace(/\u00a0/g, " ").trim();
    const hasMedia = paragraph.querySelector("img, video, iframe");
    if (!text && !hasMedia) paragraph.remove();
  });

  return template.innerHTML.trim();
}
